import { Observable } from 'rxjs';

export abstract class PdfSelectedCustomerService {
  abstract getSelectedCustomer(): Observable<any>;
}
